const autocompletes = require('./autocompletes')
const translations = require('./translations')
const courseTypes = require('./courseTypes')
const categories = require('./categories')
const languages = require('./languages')
const dayTimes = require('./dayTimes')
const weekDays = require('./weekDays')
const settings = require('./settings')
const filters = require('./filters')
const courses = require('./courses')
const schools = require('./schools')
const levels = require('./levels')
const events = require('./events')
const blog = require('./blog')
const skills = require('./skills')
const perks = require('./perks')

module.exports = {
    autocompletes,
    translations,
    courseTypes,
    categories,
    languages,
    dayTimes,
    weekDays,
    settings,
    filters,
    courses,
    schools,
    levels,
    events,
    blog,
    skills,
    perks
}
